import { useState, useEffect } from "react";

import PropTypes from "prop-types";

import {
  getSingleTile,
  getTiles,
  tilesRestartMessages,
  getTilesOfTypeLinks,
  getTileTypes,
} from "../../actions/tileActions";

import { filterMessagesRestarted } from "../../actions/filterActions";

import { connect } from "react-redux";

import { bindActionCreators } from "redux";

import { useParams, Link, useHistory } from "react-router-dom";
import Loader from "../Loader";
import {
  TILE_TYPE_GROUP_OF_TILES,
  WORKSPACE_TYPE_PRIVATE,
  LOG_IN,
  REGISTER,
} from "../../constants/stringConstants";

import AlertMessage from "../AlertMessage";

import { Container, Row, Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

import iconsShare from "../../assets/svg/icons-share.svg";

import iconsJson from "../../assets/svg/icons-json.svg";
import { GET_TILES } from "../../constants/urls";

import TabsCustom from "../TabsCustom";

import iconsBack from "../../assets/svg/icons-back.svg";

import CardAssessmentTabContent from "./CardAssessmentTabContent";

import Footer from "../../components/FooterComponents/Footer";

const CardAssessmentContainer = ({
  userToken,
  getSingleTile,
  getTiles,
  singleTileIsLoading,
  singleTile,
  filterMessagesRestarted,
  tilesRestartMessages,
  getTilesOfTypeLinks,
  tilesOfTypeLinksAreLoading,
  filterFailureMessage,
  filterSuccessMessage,
  tileErrorMessage,
  tileSuccessMessage,
  loggedIn,
  currentWorkspace,
  getTileTypes,
}) => {
  const { id } = useParams(),
    [previousId, setPreviousId] = useState(id),
    [didMount, setDidMount] = useState(false),
    [tilesAreLoaded, setTilesAreLoaded] = useState(false),
    [failureMessage, setFailureMessage] = useState(""),
    [successMessage, setSuccessMessage] = useState(""),
    [isShared, setIsShared] = useState(),
    { t } = useTranslation(),
    history = useHistory(),
    tabsObject = {
      classNameOfTabContainer: "tabs-main-container",
      classNameOfTabs: "main-tabs",
      defaultActiveKey: "overview",
      tabs: [
        {
          disabled: false,
          eventKey: "assessment",
          tabClassName: "main-tab assessmentTab",
          title: t("assessment"),
          component: !loggedIn ? (
            <Container className="three-level-message-with-register topic">
              <div className="three-level-message">
                <span className="three-lvl-msg-with-register-message fs-20">
                  {t("thisFeatureIsAvailableForRegisteredUsersOnly")}
                </span>
                <Link to={REGISTER}>
                  <Button
                    as="input"
                    type="button"
                    value={t("register")}
                    variant="cyan-green"
                    className="header-button three-level-rgst-button fs-14"
                  />
                </Link>
                <span className="three-level-msg-logIn-container">
                  <span className="three-lvl-msg-log-in-first-label">
                    {t("haveAnAccount")}
                  </span>
                  <Link to={LOG_IN}>
                    <span className="three-lvl-msg-log-in-second-label cursor-pointer">
                      {t("logIn")}
                    </span>
                  </Link>
                </span>
              </div>
            </Container>
          ) : (
            <Container className="assessment-tab-active-content-card">
              <span
                className={
                  history.location &&
                  history.location.state &&
                  history.location.state.from === "the_app"
                    ? "all-tiles-link cursor-pointer"
                    : "display-none"
                }
                onClick={() => history.goBack()}
              >
                <img
                  height={24}
                  width={24}
                  src={iconsBack}
                  className="card-assessment-container-back"
                />
                {t("allTiles")}
              </span>
              <CardAssessmentTabContent singleTile={singleTile} />
            </Container>
          ),
        },
      ],
    },
    [selectedTab, setSelectedTab] = useState("assessment");

  useEffect(() => {
    if (!didMount || id !== previousId) {
      getSingleTile(userToken, id);
      getTileTypes(userToken);
      setDidMount(true);
      setPreviousId(id);
      setTilesAreLoaded(false);
    }

    if (didMount && !tilesAreLoaded) {
      getTiles(userToken, id, "", TILE_TYPE_GROUP_OF_TILES);

      setTilesAreLoaded(true);
    }

    if (filterFailureMessage) {
      setFailureMessage(filterFailureMessage);
    }

    if (filterSuccessMessage) {
      setSuccessMessage(filterSuccessMessage);
    }

    if (tileErrorMessage) {
      setFailureMessage(tileErrorMessage);
    }

    if (tileSuccessMessage) {
      setSuccessMessage(tileSuccessMessage);
    }
  }, [
    didMount,
    setDidMount,
    getSingleTile,
    getTiles,
    id,
    userToken,
    getTilesOfTypeLinks,
    filterFailureMessage,
    filterSuccessMessage,
    tileErrorMessage,
    tileSuccessMessage,
    setTilesAreLoaded,
    tilesAreLoaded,
    getTileTypes,
    previousId,
  ]);

  function onShareClick() {
    setIsShared(true);

    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(window.location.href);
    } else {
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = window.location.href;
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        // here the magic happens
        document.execCommand("copy") ? res() : rej();
        textArea.remove();
      });
    }
  }

  function onShareClose() {
    setIsShared(false);
  }

  if (singleTileIsLoading || tilesOfTypeLinksAreLoading) {
    return <Loader />;
  }

  console.log("Card assessment container", singleTile);

  return (
    <Container
      expand="lg"
      className="home-page-container document-homepage-container card-assessment-container"
    >
      {!singleTileIsLoading &&
      !tilesOfTypeLinksAreLoading &&
      Object.keys(singleTile).length !== 0 &&
      singleTile.constructor === Object ? (
        <>
          <Row className="main-heading-row topic-heading-row">
            <span className={"heading fs-21"}>{singleTile.TILE_NAME}</span>
          </Row>
          <Row className="subline-heading-row">
            <span className={"subheading fs-10"}>
              {t("createdBy") + ": "}
              <img
                width={24}
                height={24}
                src={singleTile.CREATOR_LOGO}
                className={
                  singleTile.CREATOR_LOGO
                    ? "created-by-logo-tile"
                    : "display-none"
                }
              />
              {singleTile.CREATED_BY}
            </span>
            <span className="topic-subheading-right-options fs-14">
              <span
                className={
                  !loggedIn
                    ? "topic-subheading-option padding-right-32 cursor-not-allowed"
                    : "topic-subheading-option padding-right-32 topic-subheading-options-logged-in cursor-pointer"
                }
              >
                <Link
                  className={
                    !loggedIn ||
                    currentWorkspace.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE
                      ? "topic-subheading-option no-link-decoration cursor-not-allowed"
                      : "cursor-pointer topic-subheading-options-logged-in"
                  }
                  onClick={(event) => {
                    event.preventDefault();

                    if (
                      loggedIn &&
                      currentWorkspace.WORKSPACE_TYPE !== WORKSPACE_TYPE_PRIVATE
                    )
                      window.open(
                        GET_TILES +
                          "?usertoken=" +
                          userToken +
                          "&tile_id=" +
                          singleTile.TILE_ID +
                          "&tile_type=" +
                          TILE_TYPE_GROUP_OF_TILES
                      );
                  }}
                >
                  <img
                    width={"24px"}
                    height={"24px"}
                    src={iconsJson}
                    className="topic-subheading-option-icon"
                  />
                  <span className="topic-subheading-option-label">
                    {t("getJSONStream")}
                  </span>
                </Link>
              </span>
              <span
                onClick={() => onShareClick()}
                className={
                  "topic-subheading-option cursor-pointer topic-subheading-options-logged-in"
                }
              >
                <img
                  width={"24px"}
                  height={"24px"}
                  src={iconsShare}
                  className="topic-subheading-option-icon"
                />
                <span className="topic-subheading-option-label">
                  {t("share")}
                </span>
              </span>
            </span>
          </Row>
          <hr className="horizontal-ruler topic-horizontal-ruler" />
          <TabsCustom
            classNameOfTabs={tabsObject.classNameOfTabs}
            defaultActiveKey={tabsObject.defaultActiveKey}
            tabs={tabsObject.tabs}
            classNameOfTabContainer={tabsObject.classNameOfTabContainer}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
          <Footer />
        </>
      ) : (
        <div className="display-none" />
      )}
      {isShared ? (
        <AlertMessage
          variant="success"
          onClose={() => onShareClose()}
          successHeading={t("success")}
          mainMessage={t("copyURLMessage")}
        />
      ) : (
        <div className="display-none" />
      )}
      {failureMessage ? (
        <AlertMessage
          variant="danger"
          onClose={() => {
            filterMessagesRestarted();
            tilesRestartMessages();
            setFailureMessage("");
          }}
          successHeading={t("failure")}
          mainMessage={failureMessage}
        />
      ) : (
        <div className="display-none" />
      )}
      {successMessage ? (
        <AlertMessage
          variant="success"
          onClose={() => {
            filterMessagesRestarted();
            tilesRestartMessages();
            setSuccessMessage("");
          }}
          successHeading={t("success")}
          mainMessage={successMessage}
        />
      ) : (
        <div className="display-none" />
      )}
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    userToken: state.configReducer.userToken,
    singleTileIsLoading: state.tileReducer.singleTileIsLoading,
    singleTile: state.tileReducer.singleTile,
    tilesOfTypeLinksAreLoading: state.tileReducer.tilesOfTypeLinksAreLoading,
    filterFailureMessage: state.filterReducer.filterFailureMessage,
    filterSuccessMessage: state.filterReducer.filterSuccessMessage,
    tileSuccessMessage: state.tileReducer.tileSuccessMessage,
    tileErrorMessage: state.tileReducer.tileErrorMessage,
    loggedIn: state.userReducer.loggedIn,
    currentWorkspace: state.configReducer.currentWorkspace,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSingleTile: bindActionCreators(getSingleTile, dispatch),
    getTiles: bindActionCreators(getTiles, dispatch),
    filterMessagesRestarted: bindActionCreators(
      filterMessagesRestarted,
      dispatch
    ),
    tilesRestartMessages: bindActionCreators(tilesRestartMessages, dispatch),
    getTilesOfTypeLinks: bindActionCreators(getTilesOfTypeLinks, dispatch),
    getTileTypes: bindActionCreators(getTileTypes, dispatch),
  };
};

CardAssessmentContainer.propTypes = {
  userToken: PropTypes.string,
  getSingleTile: PropTypes.func.isRequired,
  getTiles: PropTypes.func.isRequired,
  singleTileIsLoading: PropTypes.bool.isRequired,
  singleTile: PropTypes.shape({
    TILE_NAME: PropTypes.string,
    TILE_LAST_UPDATE: PropTypes.string,
    TILE_ID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    CREATOR_LOGO: PropTypes.string,
    CREATED_BY: PropTypes.string,
  }).isRequired,
  filterMessagesRestarted: PropTypes.func.isRequired,
  tilesRestartMessages: PropTypes.func.isRequired,
  getTilesOfTypeLinks: PropTypes.func.isRequired,
  tilesOfTypeLinksAreLoading: PropTypes.bool.isRequired,
  filterFailureMessage: PropTypes.string.isRequired,
  filterSuccessMessage: PropTypes.string.isRequired,
  tileSuccessMessage: PropTypes.string.isRequired,
  tileErrorMessage: PropTypes.string.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  currentWorkspace: PropTypes.shape({
    WORKSPACE_TYPE: PropTypes.string,
  }).isRequired,
  getTileTypes: PropTypes.func.isRequired,
};

CardAssessmentContainer.defaultProps = {
  userToken: "",
  getSingleTile: () => {},
  getTiles: () => {},
  singleTileIsLoading: false,
  singleTile: {},
  filterMessagesRestarted: () => {},
  tilesRestartMessages: () => {},
  getTilesOfTypeLinks: () => {},
  tilesOfTypeLinksAreLoading: false,
  tileSuccessMessage: "",
  tileErrorMessage: "",
  filterFailureMessage: "",
  filterSuccessMessage: "",
  loggedIn: false,
  currentWorkspace: {},
  getTileTypes: () => {},
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardAssessmentContainer);
